import { render, staticRenderFns } from "./StepCleaningAir.vue?vue&type=template&id=b2891da2&scoped=true&"
import script from "./StepCleaningAir.vue?vue&type=script&lang=js&"
export * from "./StepCleaningAir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2891da2",
  null
  
)

export default component.exports